import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';
import { updateMissionKeyword, useSendMissionKeywordDataMutation } from 'store/missionKeyword';

// Keywordを管理するためのカスタムフック
export function useMissionKeyword(mission: string) {
  const dispatch = useDispatch();
  const missionKeywordState = useSelector((state: RootState) => state.missionKeyword);

  const { keyword, isInitialize, progress, result } = missionKeywordState;
  const [lastResult, setLastResult] = useState<boolean | null>(null);

  const [sendMissionKeywordData, { isLoading: isSubmittingKeyword, error: submitKeywordError }] =
    useSendMissionKeywordDataMutation();

  const updateKeywordState = (newMissionKeyword: string) => {
    dispatch(updateMissionKeyword(newMissionKeyword));
  };

  const sendKeyword = async (keyword: string) => {
    try {
      const result = await sendMissionKeywordData({ keyword, mission }).unwrap();
      setLastResult(result.result);
    } catch (error) {
      console.error('Failed to send keyword: ', error);
    }
  };

  return {
    keyword,
    isInitialize,
    progress,
    isSubmittingKeyword,
    submitKeywordError,
    updateKeywordState,
    sendKeyword,
    result,
    lastResult,
  };
}
